import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import { Close, PlayArrow } from '@mui/icons-material';
import { FC } from 'react';

interface VideoViewOnlyModalProps {
  open: boolean;
  onClose: () => void;
  videoUrl: string | null;
  questionText?: string;
}

export const VideoViewOnlyModal: FC<VideoViewOnlyModalProps> = ({
  open,
  onClose,
  videoUrl,
  questionText,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          maxHeight: '90vh',
          m: { xs: 0, sm: 2 },
        },
      }}
    >
      <DialogTitle sx={{ pb: 1, px: { xs: 2, sm: 3 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center' }}>
            <PlayArrow sx={{ mr: 1 }} />
            Video Answer
          </Typography>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>
        {questionText && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1, pr: { xs: 4, sm: 0 } }}>
            {questionText}
          </Typography>
        )}
      </DialogTitle>

      <DialogContent sx={{ px: { xs: 2, sm: 3 }, py: 2 }}>
        <Box
          sx={{
            width: '100%',
            aspectRatio: '16/9',
            borderRadius: { xs: 2, sm: 3 },
            overflow: 'hidden',
            backgroundColor: 'grey.100',
            border: '1px solid',
            borderColor: 'divider',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {videoUrl ? (
            <video
              controls
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
              src={videoUrl}
            >
              Your browser does not support the video tag.
            </video>
          ) : (
            <Box sx={{ textAlign: 'center', p: 4 }}>
              <PlayArrow sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
              <Typography variant="body1" color="text.secondary">
                No video available
              </Typography>
            </Box>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}; 